import { render, staticRenderFns } from "./DetalhamentoQtdeDiasRuptura.vue?vue&type=template&id=b76d7d2c"
import script from "./DetalhamentoQtdeDiasRuptura.vue?vue&type=script&setup=true&lang=js"
export * from "./DetalhamentoQtdeDiasRuptura.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports